import styled from 'styled-components';

import hairBg from '../../../assets/hair.svg';
import media from '../../../styles/media.style';
import { MOBILE_PADDING, BG_GRAY, PAGE_WIDTH } from '../../../styles/variables.style';

export const Wrapper = styled.section`
  background: center / cover no-repeat url(${hairBg}), ${BG_GRAY.COMMON_1};
  padding: 2em ${MOBILE_PADDING}px;
  max-width: ${PAGE_WIDTH}px;
  width: 100%;
  margin: 0 auto;

  main div section + & {
    margin-top: 0;
  }

  ${media.tabletL`
    padding: 8em 0;
  `};
`;

export const ContentText = styled.p`
  font-size: 20px;
  text-align: center;
  max-width: 690px;
  margin: 0 auto;

  ${media.tabletL`
    font-size: 32px;
  `};
`;

export const AuthorText = styled.div`
  text-align: center;
  margin-top: 1em;

  > p {
    font-size: 14px;
    margin: 0;
  }

  ${media.tabletL`
    margin-top: 2em;

    > p {
      font-size: 18px;
    }
  `};
`;

export const Name = styled.p`
  text-transform: uppercase;
`;

export const Title = styled.p`
  font-weight: 400;
`;



// WEBPACK FOOTER //
// ./src/pages/EditorialPage/Quote/Quote.style.js